/* Range Planning Items Client barrel export */

import { RangePlanningItemsClientMocked } from './rangePlanningItemsClientMocked';

// Re-export types
export * from './rangePlanningItemsTypes';

// No real backend exists yet - always use the in-code mocked client.
const rangePlanningItemsClient = new RangePlanningItemsClientMocked();

export { rangePlanningItemsClient, RangePlanningItemsClientMocked };
export type { IRangePlanningItemsClient } from './IRangePlanningItemsClient';
